var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCountDownVisible)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.slide.stopSubmission),expression:"!slide.stopSubmission"}],ref:"timeToAnswer"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }